const forms = [
  {
    name: "Debit Note",
    className: "bg-white p-4 rounded-md p-8 w-[100%] mx-auto",
    options: [
      {
        name: "Purchase Order",
        type: "select",
        form: {
          name: "purchase_order",
          allowClear: false,
          showSearch: true,
          filterOption: false,
          placeholder: "Select Purchase Order",
          api: "get-all-purchase-orders",
          options: null,
          value: null,
          required: true,
          source:"Credit/Debit_Note"
        },
      },
      {
        name: "Supplier",
        type: "input",
        form: {
          name: "supplier",
          value: "",
          required: false,
        },
      },
      {
        name: "Date",
        type: "date",
        form: {
          type: "text",
          name: "date",
          placeholder: "Debit Note Date",
          class: "",
          value: new Date(),
          required: true,
        },
      },
      {
        name: "Reason",
        type: "input",
        form: {
          name: "reason",
          placeholder: "Reason for debit note",
          value: "",
          required: true,
        },
      },
    ],
  },
];

export default forms;